import { BrandImage } from "../brand-image";

const Navbar = () => {
    return (
        <>
            <div>
                <BrandImage />
            </div>
        </>
    )
}

export { Navbar }
